import React from "react";
import InputField from "./InputField";
import Dropdown from "./Dropdown";
import Switch from "./Switch";
import SuggestInputField from "./SuggestInputField";
import { format, parseISO } from "date-fns";
import ToolTip from "./ToolTip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons";

const EditForm = ({ 
  data, 
  setData, 
  setHasChanges, 
  disabled, 
  fields, 
}) => {

  const formatDate = (date) => {
    if (!date) return "";
    try {
      return format(parseISO(date), "yyyy-MM-dd");
    } catch (error) {
      return date;
    }
  };

  const handleInputChange = (field, value) => {
    setData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
    setHasChanges(true);
  };

  return (
    <div className="grid grid-cols-2 gap-6 w-full">
      {fields.map((field) => {
        const { 
          key, 
          label, 
          type, 
          tooltip, 
          disabled:fieldDisabled,
          options,
          maxLength 
        } = field;
        
        return (
          <div key={key} className="flex flex-col gap-4">
            {type === "dropdown" ? (
              <Dropdown
                label={label}
                value={[data?.[key]] || ""}
                options={options?.map((opt) => opt.label) || []}
                onSelect={(selectedLabel) => {
                  const selected = options?.find((opt) => opt.label === selectedLabel);
                  handleInputChange(key, selected?.value || "");
                }}
                disabled={fieldDisabled ?? disabled}
              />
            ) : type === "suggest" ? (
              <SuggestInputField
                label={label}
                value={data?.[key] || ""}
                options={options}
                placeholder={label}
                disabled={fieldDisabled ?? disabled}
                onChange={(value) => handleInputChange(key, value)}
              />
            ) : type === "switch" ? (
              <div className="flex flex-col w-1/2">
                <label className="text-sm font-bold pb-2">{label}</label>
                <div className="flex items-center space-x-2">
                  <Switch
                    checked={data?.[key] || false}
                    onChange={(checked) => handleInputChange(key, checked)}
                    disabled={fieldDisabled ?? disabled}
                  />
                  <p className="text-sm">{data?.[key] ? "Enabled" : "Disabled"}</p>
                </div>
              </div>
            ) : (
              <div className="flex flex-col">
                <label className="text-sm font-bold flex space-x-2">
                  <span>{label}</span>
                  {tooltip && (
                    <ToolTip text={tooltip}>
                      <FontAwesomeIcon
                        icon={faInfoCircle}
                        className="text-gray-400 text-md"
                      />
                    </ToolTip>
                  )}
                </label>
                <InputField
                  placeholder={label}
                  type={type}
                  value={type === "date" ? formatDate(data?.[key]) : data?.[key] || ""}
                  onChange={(e) => handleInputChange(key, e.target.value)}
                  readOnly={type === "readonly"}
                  className="w-full"
                  disabled={fieldDisabled ?? disabled}
                  maxLength={maxLength}
                />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default EditForm;
